import React, { useEffect, useState } from 'react';
import { useUser } from '../context/UserContext';
import ClientLayout from './ClientLayout';
import GuestLayout from './GuestLayout';
import AdminLayout from './AdminLayout';
import { useLocation } from 'react-router-dom';
import ClientLayoutV2 from './ClientLayoutV2';
import AdminLayoutV2 from './AdminLayoutV2';

const MainLayout = () => {
  const { user } = useUser();
  const [roleKey, setRoleKey] = useState(user?.role_key || '');

  const location = useLocation();

  useEffect(() => {
    document.body.classList.remove('ai_assistant_body');
    if (location.pathname === "/ai_assistant") {
      document.body.className = "ai_assistant_body";
    } else {
      document.body.className = "";
    }
  }, [location.pathname]);

  useEffect(() => {
    // Update roleKey state when user changes
    if (user?.role_key) {
      setRoleKey(user.role_key);


      // Start: Add LiveChat script dynamically
      const script = document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.src = 'https://cdn.livechatinc.com/tracking.js';
      script.id = 'livechat-script';
      
      window.__lc = window.__lc || {};
      window.__lc.license = 19001633;
      window.__lc.integration_name = 'manual_onboarding';
      window.__lc.product_name = 'livechat';
 
      if (user?.email) {
        window.__lc.visitor = {
          name: user?.firstname && user?.firstname ? `${user.firstname} ${user.lastname}` : user?.firstname || user?.lastname || 'Guest',
          email: user?.email || ''
        };
      }

      // Append the script to the document head
      document.head.appendChild(script);

      // Clean up script when component unmounts
      // return () => {
      //   document.head.removeChild(script);
      // };

      setTimeout(() => {
        const chatContainer = document.getElementById('chat-widget-container');
        if (chatContainer && user?.role_key) {
          if(user?.role_key !== 'CLIENT' && user?.role_key !== 'CLIENT_EMPLOYEE'){
            chatContainer.style.display = 'none';
          }else{
            chatContainer.style.display = 'block';
          }
        }
      }, 3000)

    }
  }, [user]);

  // Conditionally render layouts based on the roleKey
  if (roleKey === 'CLIENT' || roleKey === 'CLIENT_EMPLOYEE' || roleKey === 'SALES_DEMO' || roleKey === 'ANALYST') {
    return <ClientLayoutV2 />;
  } else if(!roleKey) {
    return <GuestLayout />;
    }

  return <AdminLayoutV2 />;
};

export default MainLayout;
